import { Modal, Table } from 'antd'
import { first } from 'lodash'
import { useEffect, useState } from 'react'
import { apiGetTickets } from 'src/store/sagas/checkIn'
import styled from 'styled-components'

export const ModalStyled = styled(Modal)`
  border-radius: 20px;
  color: #ffffff;
  .ant-modal-header {
    background: transparent;
  }
  .ant-modal-content {
    background: #fff;
  }

  ::placeholder {
    color: #757575;
    font-size: 14px;
    font-weight: 400;
  }
`
export const CheckInQrModal = ({ ticketIds, openCheckInQrModal, setOpenCheckInQrModal }) => {
  const [data, setData] = useState([])
  useEffect(
    () => {
      fetchTickets(ticketIds)
      return () => {
        setOpenCheckInQrModal(false)
      }
    },  
    [ticketIds]
  )

  const fetchTickets = async (ticketIds) => {
    const filter = [
      {
        column: 'ids',
        text: ticketIds.join(','),
      }
    ]
   const response = await apiGetTickets({ filter: JSON.stringify(filter) })
   setData(response?.data?.items || [])
  }

  const columns = [
    {
      title: 'Khu vực',
      dataIndex: 'areaCode',
      key: 'areaCode',
    },
    {
      title: 'Vị trí',
      dataIndex: 'seat',
      key: 'seat',
      render: (_, record) => first(record?.seat)
    },
    {
      title: 'QR check in',
      dataIndex: 'checkInCode',
      key: 'checkInCode',
      render: (_, record) => (
        <img src={record?.checkInCode} className="w-full" alt="qrCode" />
      )
    }
    
  ]

  return (
      <ModalStyled
        open={openCheckInQrModal}
        closable={true}
        onCancel={() => setOpenCheckInQrModal(false)}
        footer={null}
        wrapClassName="!bg-[#00000070]"
        className="relative"
      >
        <Table
            className="w-full text-black"
            columns={columns}
            dataSource={data}
            pagination={false}
          />
      </ModalStyled>
  )
}
